export function classifyImageUploadError(error, response) {
  const status = response?.status
  const detail = error?.message || ''
  const lowered = detail.toLowerCase()

  if (error?.name === 'NotAllowedError' || error?.name === 'SecurityError' || lowered.includes('permission')) {
    return 'Accès au presse-papier refusé. Autorisez le collage dans le navigateur.'
  }
  if (error?.name === 'NotFoundError' || lowered.includes('aucune image')) {
    return 'Aucune image dans le presse-papier.'
  }
  if (status === 400 || lowered.includes('type') || lowered.includes('format') || lowered.includes('incohérence')) {
    return 'Ce format d’image n’est pas accepté.'
  }
  if (status === 401 || status === 403 || lowered.includes('stockage') || lowered.includes('unauthorized')) {
    return 'Enregistrement de l’image refusé par le stockage. Reconnectez-vous puis réessayez.'
  }
  if (status >= 500 || lowered.includes('transfert') || lowered.includes('failed') || lowered.includes('network')) {
    return 'Le transfert de l’image a échoué. Réessayez.'
  }
  return detail || 'Impossible d’enregistrer l’image.'
}
